import updateKeyStrokeCounterViewStateAction from '../actions/updateKeyStrokeCounterViewStateAction';
import { KeyStrokeCounterViewState } from '../store/schema/KeyStrokeCounterViewState';
import { PluginViewStateAdapter, PluginWithViewState } from 'owa-editor';
import { Editor } from 'roosterjs-editor-core';
import { PluginEvent, PluginEventType } from 'roosterjs-editor-types';

/**
 * The purpose of this plugin is to count the number of keystrokes a user makes
 * when composing a message.
 * Note: The values of the keys themselves are not observed.
 */
export default class KeyStrokeCounterPlugin
    implements PluginWithViewState<KeyStrokeCounterViewState> {
    private keyStrokeCount: number;

    public getName() {
        return 'KeyStrokeCounter';
    }

    constructor(readonly adapter: PluginViewStateAdapter<KeyStrokeCounterViewState>) {
        this.keyStrokeCount = 0;
    }

    public initialize(editor: Editor) {}

    public dispose() {}

    // Count keystrokes locally
    // When the ExtractContent event fires (guaranteed before message is sent), we update the viewState
    // for consumption by the MailComposeSend datapoint.
    onPluginEvent(event: PluginEvent): void {
        if (event.eventType === PluginEventType.Input) {
            this.keyStrokeCount++;
        } else if (event.eventType === PluginEventType.ExtractContent) {
            const viewState: KeyStrokeCounterViewState = this.adapter();
            updateKeyStrokeCounterViewStateAction(viewState, this.keyStrokeCount);
        }
    }
}
